import { createApi } from '@reduxjs/toolkit/query/react';
import { baseApiQuery } from '../basequery';
import type { GetCustomersResponse } from '../../types/customers';

export interface GetCustomersParams {
  name?: string;
  page?: number;
  size?: number;
  filters?: {
    logic: string;
    conditions: Array<{
      field: string;
      operator: string;
      value: unknown;
    }>;
  };
}

// Wrapper type for useDataGridState compatibility
interface GetCustomersQueryArg {
  params?: GetCustomersParams;
}

export const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: baseApiQuery,
  tagTypes: ['Customers'],
  endpoints: (builder) => ({
    getCustomers: builder.query<GetCustomersResponse, GetCustomersQueryArg | void>({
      query: (arg) => {
        // Extract params from wrapper object (useDataGridState passes { params: {...} })
        const params = arg?.params ?? {};
        return {
          url: '/customers',
          method: 'GET',
          params: {
            page: params.page,
            size: params.size,
            ...(params.name && { name: params.name }),
            ...(params.filters && { filters: params.filters }),
          },
        };
      },
      providesTags: ['Customers'],
    }),
  }),
});

export const { useGetCustomersQuery, useLazyGetCustomersQuery } = customerApi;
